import React from 'react';

export default function IconSettingRules() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_652_327)">
        <path
          d="M9 14.833C12.2217 14.833 14.8333 12.2214 14.8333 8.99972C14.8333 5.77805 12.2217 3.16638 9 3.16638C5.77834 3.16638 3.16666 5.77805 3.16666 8.99972C3.16666 12.2214 5.77834 14.833 9 14.833Z"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99992 7.54108V11.6244"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.83326 11.6244H10.1666"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.4166 7.54108H8.99993"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.83743 6.08275C8.83743 6.08156 8.83779 6.07891 8.83898 6.07608C8.84001 6.07365 8.84124 6.07204 8.84231 6.07097C8.84338 6.0699 8.84499 6.06867 8.84742 6.06764C8.85025 6.06645 8.8529 6.06609 8.85409 6.06609C8.85529 6.06609 8.85794 6.06645 8.86076 6.06764C8.86319 6.06867 8.86481 6.0699 8.86588 6.07097C8.86695 6.07204 8.86818 6.07365 8.8692 6.07608C8.8704 6.07891 8.87076 6.08156 8.87076 6.08275C8.87076 6.08395 8.8704 6.0866 8.8692 6.08943C8.86818 6.09185 8.86695 6.09347 8.86588 6.09454C8.86481 6.09561 8.86319 6.09684 8.86076 6.09786C8.85794 6.09906 8.85529 6.09942 8.85409 6.09942C8.8529 6.09942 8.85025 6.09906 8.84742 6.09786C8.84499 6.09684 8.84338 6.09561 8.84231 6.09454C8.84124 6.09347 8.84001 6.09185 8.83898 6.08943C8.83779 6.0866 8.83743 6.08395 8.83743 6.08275Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_652_327">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
